import { createGlobalStyle } from 'styled-components';

import monseratt from '../assets/fonts/montserrat.woff';

const Typography = createGlobalStyle`
    @font-face {
        font-family: Monseratt;
        src: url(${monseratt});
    }

    html {
        font-family: Monseratt, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }

    p, li {
        letter-spacing: 0.5px;
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: normal;
        margin: 0;
    }

    a {
        color: var(--grey);
        text-decoration-color: var(--white);
    }

    mark {
        background: var(--yellow);
        padding: 0 2px 2px 2px;
        margin: 0;
        display: inline;
        line-height: 1;
    }
`;

export default Typography;
